module.exports = __webpack_public_path__ + "static/media/foto_serwis.491f10c6.jpg";